export default __webpack_public_path__ + "static/media/ilustracao-mulher-mostrando-passos-espelhado.0705738b.svg";